import {useState, useEffect, useRef} from 'react'
import {useSearchParams} from 'react-router-dom'

import Style from './style'

import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import TStyle from 'shared/style/tableStyle'

import useGetAccountList from 'entity/account/useGetAccountList'
import usePostAccountParticipationTicketGive from 'entity/account/usePostAccountParticipationTicketGive'

import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'
import usePostAccountStoreTicketGive from 'entity/account/usePostAccountStoreTicketGive'
import useRoleCookie from 'shared/model/useRoleCookie'
import {ROLE_COMPETITION_MANAGER} from 'shared/constant/lookup/role'

const GiveModal = ({eventIdx, closeEvent, ticketTypeId, isStoreEvent}) => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const [userRole] = useRoleCookie()

	const [accountIdx, setAccountIdx] = useState()

	const [accountList, isLoading] = useGetAccountList({
		enableSearchGlobally: true,
	})
	const [giveOfficalTicket] = usePostAccountParticipationTicketGive(
		eventIdx,
		accountIdx
	)

	const [postStoreTicket] = usePostAccountStoreTicketGive(
		accountIdx,
		'1',
		ticketTypeId,
		false
	)

	const sizeList = ['short', 'short', 'medium', 'expand', 'medium', 'medium']
	const tableHeadList = [
		{label: '선택'},
		{label: 'IDX', sortKey: 'idx'},
		{label: '이름', sortKey: 'name'},
		{label: '닉네임', sortKey: 'nickname'},
		{label: '연락처', sortKey: 'contact'},
		{label: '프로 자격', sortKey: 'pro_grade_flag'},
	]
	const tableDataList = accountList?.data?.account_list

	const changeCheckboxEvent = (idx) => {
		if (accountIdx !== idx) setAccountIdx(idx)
		else setAccountIdx(null)
	}

	useEffect(() => {
		setAccountIdx(null)
	}, [page, search])

	return (
		<DefaultModal title={'참가권 지급'} closeEvent={closeEvent}>
			<Style.Wrapper>
				<Search
					placeholder='IDX, 이름, 닉네임, 연락처로 검색'
					qualificationFilter={userRole !== ROLE_COMPETITION_MANAGER}
					statusFilter={userRole !== ROLE_COMPETITION_MANAGER}
					searchGroup='account'
					searchInputFullWidth
				/>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										<SortableHeader sortKey={elem.sortKey}>
											{elem.label}
										</SortableHeader>
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{tableDataList?.map((elem, index) => (
								<TStyle.TableRow
									key={index}
									$odd={index % 2 === 1}
									onClick={() => changeCheckboxEvent(elem?.idx)}
								>
									<TStyle.Data $size={sizeList[0]}>
										<input
											type='checkbox'
											checked={accountIdx === elem?.idx}
											readOnly
										/>
									</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>
										{elem?.nickname}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>{elem?.contact}</TStyle.Data>
									<TStyle.Data $size={sizeList[5]}>
										{convertProGradeAsName[elem?.pro_grade_flag]}
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={accountList?.data?.max_page} />

				<Style.GiveDiv>
					<DefaultButton
						small
						fitWidth
						expandHeight
						clickEvent={() => {
							if (isStoreEvent) {
								postStoreTicket()
							} else {
								giveOfficalTicket()
							}
						}}
					>
						지급
					</DefaultButton>
				</Style.GiveDiv>
			</Style.Wrapper>
		</DefaultModal>
	)
}

export default GiveModal
